import type { AdminContact, AdminInvitation } from "../../models/adminPage";
import * as styles from "./AdminPage.module.css";

type AvatarContact = Pick<AdminContact | AdminInvitation, "firstName" | "lastName" | "email">;

const avatarColors = [
  styles.avatarOrange,
  styles.avatarAmber,
  styles.avatarGreen,
  styles.avatarBlue,
  styles.avatarPurple,
  styles.avatarLavender,
  styles.avatarPink,
  styles.avatarCoral,
  styles.avatarTeal,
  styles.avatarSlate,
  styles.avatarGray,
];

export const getAvatarClass = (id: string) => {
  const index = Array.from(id).reduce(
    (value, character) => (value * 31 + character.charCodeAt(0)) % avatarColors.length,
    0
  );
  return avatarColors[index];
};

export const getMemberInitials = ({ firstName, lastName, email }: AvatarContact) =>
  `${firstName.trim().charAt(0)}${lastName.trim().charAt(0)}`.toLocaleUpperCase() ||
  email.trim().charAt(0).toLocaleUpperCase();
